'use client';
import React from 'react';
import { type AdPosition } from '@/lib/types';

/**
 * AdUnit Component - DISABLED
 * Currently returns null to prevent ad serving while awaiting AdSense approval.
 */
export function AdUnit({ type, className, slotId }: { type: AdPosition; className?: string; slotId?: string }) {
  // ADS DISABLED UNTIL APPROVAL
  return null;
}
